import React from 'react';
import { Modal } from 'antd';

const messages = [
    'The Preferred Collection Date is either empty or in the past, please enter a new date before arranging collection.',
    'Bike cannot be booked into the calendar because the settlement date will have expired by the collection date',
];
const ArrangeCollectionConfirmModal = (messageType = 0, onOk) => (
    Modal.confirm({
        title: 'Arrange Collection',
        content: messages[messageType],
        okText: 'Close',
        okCancel: false,
        onOk,
        okButtonProps: { type: 'default' },
    })
);

export default ArrangeCollectionConfirmModal;



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/ArrangeCollectionConfirmModal.js